import {GeneralTitleDefaultBox} from './general-title.default.box';
import {GeneralTitleCasino777Box} from './general-title.casino777.box';
import {GeneralTitleCasinoSIBox} from './general-title.si.box';
import {styledByTheme} from '../../themes/architecture/styled-by-theme';

export const GeneralTitleBox = styledByTheme(GeneralTitleDefaultBox)
    .forCasino777(GeneralTitleCasino777Box)
    .forSI(GeneralTitleCasinoSIBox)
    .apply();

